<template>
    <div class="tabs-holder">
        <div class="flex-gap-9 title-wrap" :key="`activities-${task?.events?.length}`">
            <h2 v-if="activitiesTitle" class="tags-title mb-3">Activities</h2>
            <div class="all-activities-wrap" @click="activitiesDropdown = !activitiesDropdown">
                <span
                    :class="['tab-label', { 'white': $route.name == 'Activities' }]"
                >{{ activeTab }}</span>
                <i :class="['icon-activities', { 'white': $route.name == 'Activities' }]"></i>
                <Dropdown v-if="activitiesDropdown" :position="$route.name == 'Activities' ? 'start' : 'end'">
                    <div v-for="item in activities_options">
                        <div
                            :class="['flex-gap-9', 'dropdown-item', {'active': activeTab == item.name}]"
                            @click="activeTab = item.name, $emit('activeTab', activeTab)"
                        >
                            <i :class="item.icon"></i>
                            <p class="activity-item">{{ item.name }}</p>
                        </div>
                    </div>
                </Dropdown>
            </div>
        </div>
        <NewComment
            v-if="showComment"
            ref="newComment"
            :task="task"
            :users_tags="tags"
            :fileUploaded="fileUploaded"
            @updateTaskEvents="updateTaskEvents"
            @hiddenCancel="$emit('hiddenCancel')"
        />
        <div v-if="activeTab == 'all'" class="tab"  :key="`all-${task?.events?.length}`">
            <EventsCard
                :openEditTask="openEditTask"
                :loader="loader"
                :task="task"
                :tags="tags"
                :events="events"
                @searchActivity="$emit('searchActivity')"
				@getEventsTask="$emit('getEventsTask')"
                :category="['logwork', 'upload', 'comment', 'edit_task_title', 'edit_task_body', 'move_task']"
                @updateTaskEvents="updateTaskEvents"
            />
        </div>
        <div v-if="activeTab == 'files'" class="tab" :key="`files-${task?.events?.length}`">
            <EventsCard
                :openEditTask="openEditTask"
                :loader="loader"
                :task="task"
                :tags="tags"
                :events="events"
                @searchActivity="$emit('searchActivity')"
				@getEventsTask="$emit('getEventsTask')"
                :category="['upload']"
                @updateTaskEvents="updateTaskEvents"
            />
        </div>
        <div v-if="activeTab == 'logs'" class="tab" :key="`logs-${task?.events?.length}`">
            <EventsCard
                :openEditTask="openEditTask"
                :loader="loader"
                :task="task"
                :tags="tags"
                :events="events"
                @searchActivity="$emit('searchActivity')"
				@getEventsTask="$emit('getEventsTask')"
                :category="['logwork']"
                @updateTaskEvents="updateTaskEvents"
            />
        </div>
        <div v-if="activeTab == 'comment'" class="tab" :key="`comment-${task?.events?.length}`">
            <EventsCard
                :openEditTask="openEditTask"
                :loader="loader"
                :task="task"
                :tags="tags"
                :events="events"
                @searchActivity="$emit('searchActivity')"
				@getEventsTask="$emit('getEventsTask')"
                :category="['comment']"
                @updateTaskEvents="updateTaskEvents"
            />
        </div>
    </div>
</template>

<script>
import EventsCard from "@/components/molecules/EventsCard.vue";
import VButton from "@/components/atoms/VButton.vue";
import NewComment from "@/components/molecules/NewComment.vue";
import Dropdown from "@/components/atoms/Dropdown.vue";

export default {
    name: "EventsTabs",
    components: {
        EventsCard,
        VButton,
        NewComment,
        Dropdown
    },
    props: ["task", "defaultActiveTab", "loader", "openEditTask", "tags", "events", "showComment", "users_tags", "fileUploaded", "activitiesTitle"],
    data() {
        return {
            activeTab: this.defaultActiveTab ? this.defaultActiveTab : 'all',
            activitiesDropdown: false,
            activities_options: [
                {
                    icon: 'icon-act-all',
                    name: 'all'
                },
                {
                    icon: 'icon-act-files',
                    name: 'files'
                },
                {
                    icon: 'icon-time',
                    name: 'logs'
                },
                {
                    icon: 'icon-act-comments',
                    name: 'comment'
                }
            ]
        };
    },
    methods: {
        updateTaskEvents() {
            this.$forceUpdate()
            this.$emit('updateTaskEvents')
        }
    }
};
</script>

<style lang="scss">
.tabs-holder {
    .tabs {
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        gap: 5px;
        max-width: 400px;
        margin-bottom: 11px;

        li {

            &:first-child {
                a {
                    border-top-left-radius: 8px;
                }
            }

            &:last-child {
                a {
                    border-top-right-radius: 8px;
                }
            }
        }
    }

    .all-activities-wrap {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        user-select: none;

        & > span { text-transform: capitalize; }

        .dropdown {
            height: auto;

            .activity-item {
                text-transform: capitalize;
                margin: 0;
            }
        }
        .tab-label.white {
            color: #fff;
        }
    }

    .tab {
        padding: 20px 0;
        color: #fff;
        border-radius: 6px;
    }
}
</style>
